<div
  class="overlay"
  lumAppLoader
  [loading]="loadingCompanies || false"
  [classes]="'loading'"
></div>

<div class="app-integration-account-manage-companies pt-4 pr-4 pl-4">
  <div class="filters flex gap-4">
    <div class="form-group w-60">
      <div class="lum-label">COMPANY</div>
      <input
        type="text"
        class="lum-input"
        matInput
        lumDebounceTime
        (debounceValue)="onFilterChange($event, 'company')"
      />
    </div>
    <div class="form-group w-60">
      <div class="lum-label">LUM-COMPANY</div>
      <div class="flex gap-2">
        <input
          type="text"
          class="lum-input"
          matInput
          lumDebounceTime
          (debounceValue)="onFilterChange($event, 'lumCompany')"
        />
      </div>
    </div>
    <div class="form-group w-60">
      <div class="lum-label">Map To</div>
      <mat-select
        class="lum-select"
        (selectionChange)="onFilterChange($event.value, 'mapTo')"
        [value]="queryParams['mapTo'] || eAppIntegrationAccountCompanyFilter.ALL"
      >
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.ALL">{{
          eAppIntegrationAccountCompanyFilter.ALL
        }}</mat-option>
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.COMPANY">{{
          eAppIntegrationAccountCompanyFilter.COMPANY
        }}</mat-option>
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.NOT_MAPPED">{{
          eAppIntegrationAccountCompanyFilter.NOT_MAPPED
        }}</mat-option>
      </mat-select>
    </div>
    <div class="flex ml-auto align-items-center gap-2">
      <button
        class="lum-button"
        [disabled]="autoMapLoading"
        (click)="onAutoMapCompanies()"
      >
        <i
          class="fa fa-sync mr-2 text-small"
          [ngClass]="{ 'fa-spin': autoMapLoading }"
        ></i>
        Auto-Map Companies
      </button>

      <button class="lum-button sync-btn" (click)="onSyncCompanies()">
        <lum-ui-icon
          icon="programming-cloud-download"
          color="#ffffff"
          width="14"
          height="14"
          class="mr-2"
        ></lum-ui-icon>
        Get Companies
      </button>
    </div>
  </div>

  <form [formGroup]="form">
    <div *ngIf="companies.length && !loadingCompanies; else empty" class="table">
      <div class="lum-table lum-table--classic striped">
        <thead class="table__head-row">
          <tr>
            <th class="w-p25">COMPANY</th>
            <th class="w-p25">LUM-COMPANY</th>
          </tr>
        </thead>
        <tbody formArrayName="companies">
          <tr
            *ngFor="
              let control of companiesFormArray?.controls;
              trackBy: trackByControlValue;
              let i = index
            "
            [formGroupName]="i"
          >
            <td>{{ control.value.name }}</td>
            <td>
              <mat-form-field class="w-100" appearance="outline">
                <input
                  matInput
                  type="text"
                  formControlName="lumCompanyName"
                  lumDebounceTime
                  [debounceTime]="500"
                  [matAutocomplete]="auto"
                  (debounceValue)="onSearchCompanies($event)"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayFn"
                  (optionSelected)="onSelectCompany($event, i)"
                >
                  <mat-option
                    *ngFor="let company of filteredCompanies; trackBy: trackById"
                    [value]="company"
                  >
                    {{ company?.business_name }}
                  </mat-option>

                  <mat-option *ngIf="loadingRfqs">
                    <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
                <button
                  *ngIf="control.value.lumCompanyName"
                  matSuffix
                  mat-icon-button
                  (click)="onClearCompany(i)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </td>
          </tr>
        </tbody>

        <mat-paginator
          [length]="pagination.total || 0"
          [pageSize]="pagination.per_page || paginationConfig.perPage"
          [pageSizeOptions]="paginationConfig.pageSizeOptions"
          [pageIndex]="(pagination.current_page || 1) - 1"
          (page)="onPaginationEvent($event)"
          aria-label="Select page"
        >
        </mat-paginator>
      </div>
    </div>
  </form>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
